/* eslint-disable no-loop-func */
import {
  defaultClient as apolloClient,
} from '@/plugins/vue-apollo';
import {
  GET_ALL_JOURNAL_ENTRIES_GQL,
  CREATE_JOURNAL_ENTRY_GQL,
} from '@/graphql/queries.gql';


export default {
  namespaced: true,

  state: {
    journalEntries: [],
    journalEntryId: null,

  },

  mutations: {
    GET_ALL_JOURNAL_ENTRIES(state, payload) {
      state.journalEntries = payload;
    },
    SET_JOURNAL_ENTRY_ID(state, payload) {
      state.journalEntryId = payload;
    },

  },
  actions: {
    getAllJournalEntries({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_ALL_JOURNAL_ENTRIES_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          console.log('in JS', data.journalEntries);
          commit('GET_ALL_JOURNAL_ENTRIES', data.journalEntries);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    async createJournalEntry({ commit }, payload) {
      console.log('payload', payload.transactions);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: CREATE_JOURNAL_ENTRY_GQL,
          variables: {
            transactionIdList: payload.transactions,
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          console.log(data);
          commit('SET_JOURNAL_ENTRY_ID', data.journalEntryId);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

  },
  getters: {
    journalEntries: state => state.journalEntries,
    journalEntryId: state => state.journalEntryId,
  },
};
